// extracted by mini-css-extract-plugin
module.exports = {"link":"AuthNav_link__2U7P1","activ":"AuthNav_activ__19I3P AuthNav_link__2U7P1"};